import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer 
      id="footer" 
      className="bg-black border-t border-white/10 py-12"
      style={{ backgroundColor: '#000000' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Company Info - Plain Text for Bank Algorithms */}
        <div className="text-left space-y-4" data-testid="footer-copyright">
          <p className="text-white font-semibold text-lg">
            PAPES US LLC
          </p>
          <p className="text-[#A3A3A3] text-sm leading-relaxed">
            2165 VAN BUREN ST, HOLLYWOOD, FLORIDA 33020, UNITED STATES
          </p>
          <p className="text-[#A3A3A3] text-sm">
            {t('footer.contact')}: Contacto@3xhoney.vip
          </p>
          <p className="text-[#A3A3A3] text-sm mt-6 pt-6 border-t border-white/10">
            {t('footer.copyright')}
          </p>
        </div>

        {/* Links Row */}
        <div className="flex flex-wrap gap-6 mt-8 pt-8 border-t border-white/10" data-testid="footer-links">
          <a href="#hero" className="text-sm text-[#A3A3A3] hover:text-[#00F0FF] transition-colors">
            Home
          </a>
          <a href="#architecture" className="text-sm text-[#A3A3A3] hover:text-[#00F0FF] transition-colors">
            Architecture
          </a>
          <a href="#predictive" className="text-sm text-[#A3A3A3] hover:text-[#00F0FF] transition-colors">
            Predictive
          </a>
          <a href="#ecosystem" className="text-sm text-[#A3A3A3] hover:text-[#00F0FF] transition-colors">
            Ecosystem
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
